import { useState } from 'react'
import useLoading from "src/hooks/useLoading"
import useCustomToast from './useCustomToast';
import usePtp from './usePtp';
import { guardarLead } from 'src/services';

const useEstadoSuscripcion = ({ idSuscripcion, idCotizacion }) => {

    const { addWarningToast, addSuccessToast, addErrorToast } = useCustomToast();
    const { consultarEstadoSuscripcion, ESTADOS_SUSCRIPCION } = usePtp();
    const loading = useLoading();
    const [estado, setTraEstado] = useState(undefined)
    const verificarSuscripcion = async () => {
        loading.setLoading(true);
        loading.setSecundario('Estamos verificando el estado de tu suscripción');
        consultarEstadoSuscripcion(idSuscripcion).then(traEstado => {
            console.log('TEST', traEstado, traEstado?.hasError);
            setTraEstado(traEstado)
            if (traEstado?.hasError) {
                guardarLead(idCotizacion, `P2P_PAGO_SUSCRIPCION__HAS_ERROR_${traEstado?.hasError}`);
            } else {
                guardarLead(idCotizacion, `P2P_PAGO_SUSCRIPCION__ESTADO_${traEstado?.estado}`);
                if (traEstado?.estado === ESTADOS_SUSCRIPCION.APROBADO) {
                    addSuccessToast(`Transacción aprobada \nRef: ${traEstado.data?.pago_id}`)
                } else if (traEstado?.estado === ESTADOS_SUSCRIPCION.PENDIENTE) {
                    addWarningToast(`Transacción pendiente \nRef: ${traEstado.data?.pago_id}`)
                } else if (traEstado?.estado === ESTADOS_SUSCRIPCION.RECHAZADO) {
                    addErrorToast(`Transacción rechazada \nRef: ${traEstado.data?.pago_id}`)
                }
            }
        }).finally(() => {
            loading.resetLoading();
        });
    }

    return { loading, estado, verificarSuscripcion }
}


export default useEstadoSuscripcion